<template>
  <modal
    name="presentationGuide"
    transition="nice-modal-fade"
    @before-open="beforeOpen"
    :clickToClose="false"
    :width="616"
    :height="518"
    :min-height="518"
  >
    <div class="container">
      <div class="heading">
        <div class="text">PPT演示模式</div>
        <div class="small-text">让动画成为演示好帮手</div>
        <div class="close icon-popup-close" @click="close"></div>
      </div>
      <video class="video" :src="videoUrl" autoplay controls></video>
      <div class="footer">
        <div class="btn" @click="showPresentation">进入全屏演示</div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {
      videoUrl: ' https://resources.laihua.com/2022-9-8/5c818c40-2f4b-11ed-acd1-2f6293e25486.mp4'
    }
  },
  computed: {

  },
  methods: {
    beforeOpen () {

    },
    close () {
      this.$modal.hide('presentationGuide');
    },
    showPresentation () {
      this.$store.commit('previewControls/layerShown', true);
      this.close();
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  margin: auto;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
  text-align: center;
  background: url(../../../assets/presentation/guide-bg.png) left top/100% 278px no-repeat;
  background-color: #ffffff;
}
.heading {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 126px;
  padding-top: 47px;
  .text {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .close {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }
}
.video {
  width: 532px;
  height: 300px;
  opacity: 1;
  border-radius: 0px;
  border: none;
}
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 32px;
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 126px;
  height: 40px;
  background: #5778FB;
  opacity: 1;
  border-radius: 4px;
  color: #fff;
  &:hover {
    background-color: #7d95f5;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/presentation/presentationGuide.vue